module.exports = __webpack_public_path__ + "img/claimArrow.d87d4d89.svg";